import { useEffect } from 'react'
import { registerFloorplanClickListener } from './useEmitFloorplanClickListener'
import type { FloorplanClickListener } from './useEmitFloorplanClickListener'

const useFloorplanClickListener = (
  callback: FloorplanClickListener,
  options: { enabled: boolean } = { enabled: true },
) => {
  useEffect(() => {
    if (!options.enabled) return
    return registerFloorplanClickListener(callback)
  }, [callback, options.enabled])
}

export default useFloorplanClickListener
